import { render } from "./DatabaseCard.vue?vue&type=template&id=5f530248&scoped=true"
import script from "./DatabaseCard.vue?vue&type=script&lang=js"
export * from "./DatabaseCard.vue?vue&type=script&lang=js"

import "./DatabaseCard.vue?vue&type=style&index=0&id=5f530248&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5f530248"

export default script